import {
  types,
  actions
} from 'reducers/coverage';
import {
  call,
  put,
  takeLatest
} from 'redux-saga/effects';
import * as api from 'services/api';

function* queryCoverage({ request }) {
  try {
    const response = yield call(api.queryCoverage, request);
    yield put(actions.querySuccess(response));
  } catch (error) {
    yield put(actions.queryFailure(error.message));
  }
}

function* showCoverage({ request, id }) {
  try {
    const response = yield call(api.showCoverage, request, id);
    yield put(actions.showSuccess(response));
  } catch (error) {
    yield put(actions.showFailure(error.message));
  }
}

export default function* rootSaga() {
  yield takeLatest(types.COVERAGE_QUERY_REQUEST, queryCoverage);
  yield takeLatest(types.COVERAGE_SHOW_REQUEST, showCoverage);
}



// WEBPACK FOOTER //
// ./src/sagas/coverage.js